import { render, staticRenderFns } from "./CurrencyInputF2.vue?vue&type=template&id=43a67eb0"
import script from "./CurrencyInputF2.vue?vue&type=script&lang=js"
export * from "./CurrencyInputF2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports